export const formatDecimal = (value: string | undefined) => {
  if(!value) return '0'
  return Number(value).toLocaleString('en-US')
}